/**
 * @module util/dayjs
 * @description Pre-configured dayjs instance with UTC and timezone plugins.
 * Import this module instead of importing dayjs directly to ensure
 * plugins are always loaded and consistent across the codebase.
 *
 * @example
 * import dayjs from "util/dayjs";
 * const now = dayjs().tz("Asia/Gaza");
 * console.log(now.format("HH:mm:ss")); // "14:30:00"
 */

import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
import timezone from "dayjs/plugin/timezone";

dayjs.extend(utc);
dayjs.extend(timezone);

export default dayjs;
